import api from "./axios";

export const getPurchaseInvoices = (params = {}) => api.get("/purchase-invoices", { params });
export const getPurchaseInvoice = (id) => api.get(`/purchase-invoices/${id}`);
export const createPurchaseInvoice = (data) => api.post("/purchase-invoices", data);
export const replacePurchaseInvoiceDraft = (id, data) => api.put(`/purchase-invoices/${id}`, data);
export const postPurchaseInvoice = (id) => api.post(`/purchase-invoices/${id}/post`);
export const recordPurchaseInvoicePayment = (id, data) => api.post(`/purchase-invoices/${id}/payments`, data);
